import { Checkbox, Col, Form, Input, InputNumber, Radio, Row, Space } from "antd"
import { useContext } from "react"
import useFeatureFlag from "../../../hooks/useFeatureFlag"
import { JOB_DETAILS_CLEANUP_FEATURE } from "../../../domain/jobs/jobs"
import LabeledSwitch from "../../common/LabeledSwitch"
import TenantsContext from "../../MyTenant/TenantsContext"
import { laborSkuSettingLabels } from "../tenantsModel"

const JobDefaultsSection = () => {
  const { state: { tenant }, dispatch } = useContext(TenantsContext)
  const jobDetailsCleanup = useFeatureFlag(JOB_DETAILS_CLEANUP_FEATURE)

  return <section>
    <Row gutter={24}>
      <Col span={6}>
        <Form.Item label={laborSkuSettingLabels.MaintenanceLaborSku}>
          <Input 
            value={tenant.maintenanceLaborSKU}
            onChange={e => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'maintenanceLaborSKU', payload: e.target.value })}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={laborSkuSettingLabels.ProjectLaborSku}>
          <Input 
            value={tenant.projectLaborSKU}
            onChange={e => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'projectLaborSKU', payload: e.target.value })}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={laborSkuSettingLabels.ServiceCallSku}>
          <Input 
            value={tenant.serviceCallSKU}
            onChange={e => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'serviceCallSKU', payload: e.target.value })}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label="Snow Divisions Group Name">
          <Input 
            value={tenant.snowDivisionsGroupName}
            onChange={e => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'snowDivisionsGroupName', payload: e.target.value })}
          />
        </Form.Item>
      </Col>
    </Row>
    <Row>
      <Col span={6}>
        <Form.Item label="Lunch Breaks">
          <LabeledSwitch 
            label="Automatically Assigned" 
            value={tenant.hasLunchBreaks}
            onChange={checked => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'hasLunchBreaks', payload: checked })}
          />
        </Form.Item>
        <Form.Item label="Default Lunch Breaks">
          <InputNumber 
            addonAfter="minutes" 
            value={tenant.defaultLunchBreak}
            onChange={value => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'defaultLunchBreak', payload: value })}
          />
        </Form.Item>
        <p>*Lunch break will be added at 12:00 PM</p>
      </Col>
      <Col span={6}>
        <Form.Item label="Manage Time Gaps Between Jobs">
          <Radio.Group value={tenant.closeUnbillableGaps} onChange={e => dispatch({ type: 'SET_CLOSE_UNBILLABLE_GAPS', payload: e.target.value })}>
            <Radio value={true}>Automatically close unbillable gaps between jobs</Radio>
            <Radio value={false}>Leave gaps between jobs as unbillable time</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>
      {jobDetailsCleanup && <Col span={6}>
        <Form.Item label="Required at Clock-Out" extra="Crews are asked for these before finishing a visit. Each job can override this.">
          <Space direction="vertical">
            <Checkbox
              checked={tenant.requireClockOutNotes ?? false}
              onChange={e => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'requireClockOutNotes', payload: e.target.checked })}
            >Internal note</Checkbox>
            <Checkbox
              checked={tenant.requireClockOutPhoto ?? false}
              onChange={e => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'requireClockOutPhoto', payload: e.target.checked })}
            >Photo</Checkbox>
          </Space>
        </Form.Item>
      </Col>}
    </Row>
  </section>
}

export default JobDefaultsSection